var _style, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoDiscoveredLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#F800FF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{display:none;}\n\t.st4{display:inline;}\n\t.st5{display:inline;fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle__13_",
    className: "st0",
    width: 32,
    height: 32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10,10H6.8C10.1,4.9,16.9,3.5,22,6.8c3.1,2,5,5.5,5,9.2h2c0-7.2-5.8-13-13-13C12.1,3,8.5,4.7,6,7.7V4H4v8h6V10z M23,22h2.2 c-3.3,5.1-10.1,6.5-15.2,3.2c-3.1-2-5-5.5-5-9.2H3c0,7.2,5.8,13,13,13c3.9,0,7.5-1.7,10-4.7V28h2v-8h-5V22z M16,8c-2.2,0-4,1.8-4,4 v2.3c-0.6,0.4-1,1-1,1.7v5c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2v-5c0-0.7-0.4-1.4-1-1.7V12C20,9.8,18.2,8,16,8z M14,12 c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2v2h-4V12z M19,21h-6v-5h6V21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoDiscoveredLock);
export default __webpack_public_path__ + "static/media/auto-discovered-lock.34a3cd3754079b254ac72a894f22475a.svg";
export { ForwardRef as ReactComponent };